// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-NL';

import popularKeyword from './popularKeyword';

// Tenant-specific styles
import '../../../scss/popularKeywordPage/popularKeyword.mp.nlnl.scss';

popularKeyword(i18n);
